import $ from "jquery";

function transformRow($currentTable, $row, i) {
  const label = $row.text();
  $row.addClass("table-label");
  $currentTable.find("tr").each(function () {
    $(this).find("td").eq(i).attr("data-label", label);
  });
}

function init(): void {
  // Add data-labels to tables that show on mobile version
  $("table").each(function () {
    const $currentTable = $(this);

    if ($currentTable.parent().hasClass("table-scrollable")) {
      return;
    }

    $currentTable.addClass("table--responsive");
    // If there are headings, use them
    if ($currentTable.find("th").length) {
      $currentTable.find("th").each(function (i) {
        transformRow($currentTable, $(this), i);
      });
    } else {
      // If no headings, assume first row is to be treated as a heading
      $currentTable.find("tr:first td").each(function (i) {
        transformRow($currentTable, $(this), i);
      });
    }
  });
}

export default { init };
